export const cardMediaIcons = {
  grid: "arrow_top_right",
  card: "",
  inline: "arrow_down",
};
